<template>
  <b-card>
    <div class="row mb-3 mt-3"></div>

    <div class="row">
      <div class="col-md-12 overflow-auto">
        <b-table :stacked="$mobile == 1" ref="table" class="vuetable" sort-by="answer_number" sort-desc.sync="false"
          :fields="bootstrapTable.fields" :items="dataProvider">
          <template #cell(correct_and_review)="data">
            <b-button variant="outline-info" v-b-modal.modal-scrollable @click="activity_answer_modal(data.item)">
              {{ $t("activities.correct_and_review") }}
            </b-button>
          </template>
          <!-- <template #cell(answer_number)="data">
          {{ data.item.questions[0].answer_number }}
          </template> -->
        </b-table>
        <b-spinner v-if="load" type="grow" label="Loading..." class="loading" />

        <!-- end of table -->
      </div>
      <!-- end of col -->
    </div>
    <!-- end of row -->
    <b-modal id="modal-scrollable" scrollable :title="$t('activities.questions')" ok-only
      :ok-title="$t('activities.done')" @ok="handleOk" size="lg">
      <b-row v-if="user.account_type === 'teacher'">
        <b-col cols="12">
          <b-form-group :label="$t('activities.put_grade')" label-for="smallInput">
            <b-form-input v-model="evaluation" id="smallInput" type="number" size="sm" placeholder="Small Input" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="activity.type == 'exam'">
        <b-col lg="12">
          <b-form v-for="(q, k) in questions" :key="k">
            <b-row>
              <b-col lg="2">
                <label>{{ $t("activities.question") }} {{ k + 1 }}</label>
              </b-col>
              <b-col lg="10">
                <b-form-input type="text" :value="q.question" disabled />
              </b-col>
            </b-row>
            <br />
            <b-row v-for="(answer, ke) in q.answers" :key="ke">
              <b-col lg="6">
                <b-form-input type="text" :value="answer.answer" disabled />
              </b-col>
              <b-col lg="2">
                <b-form-radio v-model="selected" name="answer" :value="q.answer_id === answer.id ? 1 : 0" :class="q.answer_id === answer.id && answer.type === 0
                    ? 'custom-control-danger'
                    : 'custom-control-success'
                  " disabled>
                </b-form-radio>
              </b-col>
            </b-row>
            <hr />
          </b-form>
        </b-col>
      </b-row>
      <b-row v-if="activity.type == 'homework'">
        <b-col lg="12">
          <b-form v-for="(question, k) in questions" :key="k">
            <b-col id="blogComment" cols="12" class="mt-2">
              <b-card>
                <b-media no-body>
                  <b-media-aside class="mr-75"> </b-media-aside>
                  <b-media-body>
                    <h4 class="font-weight-bolder mb-25">
                      {{ ++k + "-" + question.question }}
                    </h4>
                    <b-card-text v-html="question.answer"> </b-card-text>
                  </b-media-body>
                </b-media>
              </b-card>
            </b-col>
          </b-form>
        </b-col>
      </b-row>
      <b-row v-if="activity.type == 'forum'">
        <!-- blogs -->
        <b-col cols="12">
          <b-card>
            <!-- user forum answers -->
            <b-media no-body>
              <b-media-body>
                <h6 class="font-weight-bolder">
                  {{ activity.name }}
                </h6>
                <b-card-text>
                  {{ activity.questions[0].question }}
                </b-card-text>
              </b-media-body>
            </b-media>
          </b-card>
        </b-col>
        <!--/ blogs -->

        <!-- blog answers -->
        <b-col id="blogComment" cols="12" class="mt-2">
          <h6 class="section-label">
            {{ $t("activities.student_answer") }}
          </h6>
          <b-card v-for="(answer, index) in questions" :key="index">
            <b-media no-body>
              <b-media-body>
                <b-card-text>{{ answer.created_at }}</b-card-text>
                <b-card-text v-html="answer.answer" v-if="answer.answer">
                  <!-- {{answer.answer}} -->
                </b-card-text>
                <b-card-text v-else>
                  {{ $t("activities.student_uploaded_file") }}
                  <b-button variant="outline-success" :href="answer.file" target="_blank">
                    <i class="fa fa-download"></i>
                    {{ $t("activities.press_to_download") }}
                  </b-button>
                </b-card-text>
              </b-media-body>
            </b-media>
          </b-card>
        </b-col>
        <!--/ blog comment -->
      </b-row>
      <b-row v-if="activity.type == 'short_search'">
        <!-- blogs -->
        <b-col cols="12">
          <b-card>
            <!-- user forum answers -->
            <b-media no-body>
              <b-media-body>
                <h6 class="font-weight-bolder">
                  {{ activity.name }}
                </h6>
                <b-card-text>
                  {{ activity.questions[0].question }}
                </b-card-text>

                <b-card-text v-for="(answer, index) in questions" :key="index">
                  {{ $t("activities.student_uploaded_file") }}
                  <b-button variant="outline-success" target="_blank" :href="answer.file">
                    <i class="fa fa-download"></i>
                    {{ $t("activities.press_to_download") }}
                  </b-button>
                  <comment-vue :commentableid="answer.id" commentabletype="App\ActivityUserAnswer" type="text">
                  </comment-vue>
                </b-card-text>
                <!-- <b-spinner v-else type="grow" label="Loading..."  class="loading" /> -->
              </b-media-body>
            </b-media>
          </b-card>
        </b-col>
        <!--/ blogs -->
      </b-row>
    </b-modal>
  </b-card>
</template>

<script>
import ActivitiesController from "../../../../Controllers/ActivitiesController";
import Activity from "@/Apis/Activities";
import Auth from "@/Apis/Auth";
import CommentVue from "./Comment.vue";

export default {
  name: "ActivitiesDataTable",
  components: {
    CommentVue,
  },
  data() {
    return {
      filters: {},
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [
          {
            key: "grade",
            label: this.$i18n.t("activities.grade"),
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "submitDate",
            label: this.$i18n.t("activities.submitDate"),
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "answer_number",
            label: this.$i18n.t("activities.answer_number"),
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "correct_and_review",
            label: this.$i18n.t("activities.correct_and_review"),
            sortable: true,
            sortDirection: "desc",
          },
        ],
      },
      data: {},
      load: false,
      user: {},
      questions: [],
      answers: [],
      activity: {},
      selected: "1",
      grade: "",
      evaluation: null,
    };
  },
  created() { },
  methods: {
    dataProvider() {
      this.user = Auth.USER;
      this.activity = Activity.ACTIVITY;
      this.answers = Activity.STUDENT.answers;
      console.log(this.activity, this.answers);
      this.load = true;
      this.data = this.handleDataTableData(this.answers);
      this.load = false;
      return this.data;
    },
    // handleDataTableData(data) {
    //   let res = [];
    //   for (let i = 1; i <= data.length; i++) {
    //     let correct_flag = 0;
    //     let mygrade = 0;
    //     console.log();
    //     const results = data.filter((element) => {
    //       // return element.answer_number == i;
    //       return element.id == data[i - 1].id;
    //     });
    //     console.log();
    //     if (results.length > 0) {
    //       let questions = [];
    //       let submitDate = results[0].created_at;
    //       let answer_number = results[0].answer_number;
    //       results.map((el) => {
    //         if (el.grade != null) {
    //           correct_flag = 1;
    //           mygrade += el.grade;
    //         }
    //         questions.push({
    //           id: el.id,
    //           question: el.question.question,
    //           activity_question_id: el.activity_question_id,
    //           grade: el.grade,
    //           answers: el.question.answers,
    //           answer_id: el.answer_id,
    //           answer: el.answer,
    //           file: el.file,
    //           user_id: this.user.id,
    //           answer_number: el.answer_number,
    //         });
    //       });
    //       res.push({
    //         grade:
    //           correct_flag == 0
    //             ? "-"
    //             : (
    //                 (mygrade / results.length) *
    //                 (Activity.ACTIVITY.grade / 100)
    //               ).toFixed(2),
    //         submitDate: submitDate,
    //         answer_number: answer_number,
    //         questions: questions,
    //       });
    //       res.sort((p1, p2) => {
    //         if (p1.answer_number < p2.answer_number) return -1;
    //         if (p1.answer_number > p2.answer_number) return 1;
    //         return 0;
    //       });
    //     }
    //   }
    //   this.totalAnswers = res.length;
    //   console.log(res);
    //   return res;
    // },
    handleDataTableData(data) {
      let res = [];
      for (let i = 1; i <= data.length; i++) {
        let correct_flag = 0;
        let highestGrade = 0;
        console.log();
        const results = data.filter((element) => {
          // return element.answer_number == i;
          return element.id == data[i - 1].id;
        });
        console.log();
        if (results.length > 0) {
          let questions = [];
          let submitDate = results[0].created_at;
          let answer_number = results[0].answer_number;

          results.map((el) => {
            if (el.grade != null) {
              correct_flag = 1;
              // Instead of summing grades, take the highest
              if (el.grade > highestGrade) {
                highestGrade = el.grade;
              }
            }
            questions.push({
              id: el.id,
              question: el.question.question,
              activity_question_id: el.activity_question_id,
              grade: el.grade,
              answers: el.question.answers,
              answer_id: el.answer_id,
              answer: el.answer,
              file: el.file,
              user_id: this.user.id,
              answer_number: el.answer_number,
            });
          });

          res.push({
            grade:
              correct_flag == 0
                ? "-"
                : (highestGrade * (Activity.ACTIVITY.grade / 100)).toFixed(2),
            submitDate: submitDate,
            answer_number: answer_number,
            questions: questions,
          });

          // Sort by answer_number to keep the order
          res.sort((p1, p2) => {
            if (p1.answer_number < p2.answer_number) return -1;
            if (p1.answer_number > p2.answer_number) return 1;
            return 0;
          });
        }
      }

      this.totalAnswers = res.length;
      console.log(res);
      return res;
    },
    activity_answer_modal(item) {
      this.questions = item.questions;
      this.grade = item.grade;
    },
    async handleOk() {
      if (this.evaluation != null) {
        let result = this.questions.map((a) => a.id);
        this.answers.map((el) => {
          if (result.includes(el.id)) {
            el.grade = this.evaluation;
          }
        });
        let ret = await new ActivitiesController().correct_activity({
          answers_ids: result,
          grade: this.evaluation,
          activity: this.activity,
        });
        if (ret) {
          this.dataProvider();
          this.$refs.table.refresh();
          this.evaluation = null;
        }
      }
    },
  },
};
</script>
